import { useSelector } from 'react-redux';
export const useHeaderHeight = () => {
    const headerHeight = useSelector((state) => state.header.data.height);
    return `${headerHeight}px`;
};
